export const SWIPE_END = 'swipe-end';
export const SWIPE_MOVE = 'swipe-move';
export const SWIPE_START = 'swipe-start';

export const LEFT = 'left';
export const RIGTH = 'right';
export const UP = 'up';
export const DOWN = 'down';

export const SWIPE_VERTICAL = 'swipe-vertical';
export const SWIPE_HORIZONTAL = 'swipe-horizontal';
